import Vue from 'vue'
import Router from 'vue-router'

import VideoPlayer from './views/VideoPlayer.vue'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'home', component: Home},
    {path: '/player', name: 'video_player', component: VideoPlayer},
    {path: '*', component: Home}
  ]
})
